module.exports = __webpack_public_path__ + "img/brodcast-nepa-summer.381ce329.jpg";